import {
    ContexteClientFournisseurEnum,
    CriteresBenefDtoInput,
    CriteresFournisseurDtoInput,
    CriteresMoyenPaiementDtoInput,
    CriteresRibDtoInput
} from 'src/graphql/generated-types';
import { ContexteAcompte, TypeReglement } from 'src/app/board/activity/activity.constants';

const stateName = '[Shared][PaymentMethods] ';

export class SharedPaymentMethodsGetBanksListAction {
    static readonly type = stateName + 'GetBanksList';
}

export class SharedPaymentMethodsGetIbansListAction {
    static readonly type = stateName + 'GetIbansList';

    constructor(public criterias: CriteresRibDtoInput) {
    }
}

export class SharedPaymentMethodsGetDefaultBankAccountIdForActivityAction {
    static readonly type = stateName + 'GetDefaultBankAccountIdForActivity';

    constructor(public activityId: number) {
    }
}

export class SharedPaymentMethodGetCollectifAccountWithInvoicesIdsListAction {
    static readonly type = stateName + 'GetCollectifAccountWithInvoicesIdsList';

    constructor(public invoicesIdList: number[] = []) {
    }
}

export class SharedPaymentMethodsGetBankAccountWithInvoicesIdsListAction {
    static readonly type = stateName + 'GetBankAccountWithInvoicesIdsList';

    constructor(public invoicesIdList: number[] = []) {
    }
}

export class SharedPaymentMethodGetPaymentMethodsFromInvoicesIdsListAction {
    static readonly type = stateName + 'GetPaymentMethodsFromInvoicesList';

    constructor(public invoicesIdList: number[] = [], public paymentType: 'debit' | 'credit') {
    }
}

export class SharedPaymentMethodsGetLastBankForTiersAction {
    static readonly type = stateName + 'getLastBankForTiers';

    constructor(public idBeneficiaire?: number, public idFournisseur?: number) {
    }
}

// <editor-fold defaultstate="collapsed" desc="Deposit">

export class SharedPaymentMethodsInitPaymentMethodsAction {
    static readonly type = stateName + 'InitAccountingEntry';

    constructor(public initParams: {
        depositContext?: ContexteAcompte,
        paymentType?: TypeReglement,
        beneficiaryCriterias?: CriteresBenefDtoInput,
        supplierCriterias?: CriteresFournisseurDtoInput,
        paymentCriterias?: CriteresMoyenPaiementDtoInput,
    }) {
    }
}

export class SharedDepositsGetAFPAAccountIdAction {
    static readonly type = stateName + 'DepositsGetAFPAAccountId';

    constructor(public params: { supplierOrClientContext: ContexteClientFournisseurEnum, activityId: number }) {
    }
}

// </editor-fold>

export class ResetSharedPaymentMethodsStateAction {
    static readonly type = stateName + 'ResetState';
}

